import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { Response } from '../shared/models/response.model';
import { Certification } from './models/certification';

@Injectable({
  providedIn: 'root',
})
export class CertificationService {
  #http = inject(HttpClient);

  readonly BASE_URL = '/certifications';

  findAll(recherche?: string, idReferentiel?: string, niveau?: number | null) {
    let params = new HttpParams();

    if (recherche !== undefined && recherche !== null) {
      recherche = recherche.normalize('NFD').replace(/[\u0300-\u036f]/g, ''); //remove Diacritic
      params = params.append('recherche', recherche);
    }

    if (idReferentiel !== undefined && idReferentiel !== null) params = params.append('idReferentiel', idReferentiel);

    if (niveau !== undefined && niveau !== null) params = params.append('niveau', niveau);

    return this.#http.get<Response<Certification>>(this.BASE_URL, { params });
  }

  parCodeFiche = (codeFiche: string, idReferentiel: string) =>
    this.#http.get<Certification>(this.BASE_URL + '/' + codeFiche, { params: { idReferentiel } });

  modifierCroisement = (idCertification: string, data: Partial<Certification>, idReferentiel: string) =>
    this.#http.patch<void>(this.BASE_URL + '/' + idCertification, data, {
      params: { idReferentiel },
    });

  modifier = (idCertification: string, data: Partial<Certification>) =>
    this.#http.put<void>(this.BASE_URL + '/' + idCertification, data);
}
